var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricTotalParticipantsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E5F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F2F8F8",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.6812 26.4127H26.2602C28.3582 26.4127 29.5373 24.1696 27.7912 23.0066C27.0903 22.5399 26.3266 22.1603 25.5153 21.8832",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7639 18.9727C22.1276 19.0683 22.5315 19.1171 22.9733 19.1171C25.2206 19.1171 26.4848 17.853 26.4848 15.6056C26.4848 13.3583 25.2206 12.0941 22.9733 12.0941C22.9471 12.0941 22.9211 12.0943 22.8951 12.0947",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8376 22.7218C24.7299 23.9821 23.4521 26.4127 21.1786 26.4127H12.641C10.3675 26.4127 9.08976 23.9821 10.982 22.7218C12.6793 21.5914 14.7176 20.9326 16.9098 20.9326C19.102 20.9326 21.1404 21.5914 22.8376 22.7218Z",
    fill: "#D7E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9126 18.4323C19.3884 18.4323 20.781 17.0397 20.781 14.564C20.781 12.0882 19.3884 10.6956 16.9126 10.6956C14.4369 10.6956 13.0443 12.0882 13.0443 14.564C13.0443 17.0397 14.4369 18.4323 16.9126 18.4323Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8376 22.7218C24.7299 23.9821 23.4521 26.4127 21.1786 26.4127H12.641C10.3675 26.4127 9.08976 23.9821 10.982 22.7218C12.6793 21.5914 14.7176 20.9326 16.9098 20.9326C19.102 20.9326 21.1404 21.5914 22.8376 22.7218Z",
    fill: "#CAE4E4",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9126 18.4323C19.3884 18.4323 20.781 17.0397 20.781 14.564C20.781 12.0882 19.3884 10.6956 16.9126 10.6956C14.4369 10.6956 13.0443 12.0882 13.0443 14.564C13.0443 17.0397 14.4369 18.4323 16.9126 18.4323Z",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricTotalParticipantsIcon);
export default __webpack_public_path__ + "static/media/metric_total_participants_icon.ceac355fd7f2cce6ccf7ac5466dfcd1e.svg";
export { ForwardRef as ReactComponent };